var _rect, _circle, _circle2, _path, _path2, _circle3, _circle4, _path3, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.0459,
    height: 22.0459,
    rx: 2.18918,
    fill: "#FFC832"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.24459,
    cy: 10.046,
    r: 2.50435,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.24482,
    cy: 10.0459,
    r: 1.39131,
    fill: "#0096FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63613 14.7767L2.85352 14.7767",
    stroke: "white",
    strokeWidth: 1.66957,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.432 14.7769L9.64941 14.7769",
    stroke: "white",
    strokeWidth: 1.66957,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9936,
    cy: 10.0462,
    r: 2.50435,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9929,
    cy: 10.0459,
    r: 1.39131,
    fill: "#0096FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1811 14.777L16.3984 14.777",
    stroke: "white",
    strokeWidth: 1.66957,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7426,
    cy: 10.0463,
    r: 2.50435,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRange);
export default __webpack_public_path__ + "static/media/range.e9ab549ed0a1460480256cca3c33f32d.svg";
export { ForwardRef as ReactComponent };